import { observable } from 'mobx';

export enum DevExtremeCssStatuses {
    Loaded,
    Error,
}

export default class DevExtremeCssService {
    private static _itemCount: number = 0;
    private static _itemSet: WeakSet<object> = new WeakSet();
    public static LinkId: string = 'devextreme-link';
    @observable public static status: DevExtremeCssStatuses | null = null;

    // use in constructor
    public static addItem(item: object) {
        DevExtremeCssService._itemSet.add(item);
        DevExtremeCssService._itemCount++;

        if (DevExtremeCssService._itemCount === 1) {
            DevExtremeCssService._loadCssFile();
        }
    }

    // use in componentWillUnmount
    public static removeItem(item: object) {
        if (DevExtremeCssService._itemSet.has(item)) {
            DevExtremeCssService._itemCount--;

            if (!DevExtremeCssService._itemCount) {
                DevExtremeCssService._unloadCssFile();
            }
        }
    }

    private static _loadCssFile() {
        if (!document.getElementById(DevExtremeCssService.LinkId)) {
            const link = document.createElement('link');

            link.id = DevExtremeCssService.LinkId;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            const root = document.getElementsByTagName('html')[0];
            link.href = root.classList.contains('dark') ? '/css/devextreme_dark.css' : '/css/devextreme.css';

            document.head.append(link);

            link.onload = DevExtremeCssService._onload;
            link.onerror = DevExtremeCssService._onerror;
        }
    }

    private static _unloadCssFile() {
        const link = document.getElementById(DevExtremeCssService.LinkId);

        if (link) {
            link.remove();

            DevExtremeCssService._setStatus(null);
        }
    }

    private static _setStatus(status: DevExtremeCssStatuses | null) {
        if (DevExtremeCssService.status !== status) {
            DevExtremeCssService.status = status;
        }
    }

    private static _onload() {
        if (document.getElementById(DevExtremeCssService.LinkId)) {
            DevExtremeCssService._setStatus(DevExtremeCssStatuses.Loaded);
        }
    }

    private static _onerror() {
        DevExtremeCssService._setStatus(DevExtremeCssStatuses.Error);
    }
}
